document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".aurevia-slider").forEach((slider) => {

    const track = slider.querySelector(".aurevia-track");
    const prev = slider.querySelector(".slider-prev");
    const next = slider.querySelector(".slider-next");

    if (!track) return;

    const getCardWidth = () => {
      const card = track.querySelector(".slider-item");
      if (!card) return 300;

      const style = window.getComputedStyle(track);
      const gap = parseInt(style.columnGap || style.gap || 0);

      return card.offsetWidth + gap;
    };

    next?.addEventListener("click", () => {
      track.scrollBy({
        left: getCardWidth(),
        behavior: "smooth"
      });
    });

    prev?.addEventListener("click", () => {
      track.scrollBy({
        left: -getCardWidth(),
        behavior: "smooth"
      });
    });

  });

});
